import React from 'react';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';

/** Only mount the chosen resource list, so switching back reloads archive changes. */
export default function ResourceTabs({ children, activeTabRef }) {
  const [active, archived] = React.Children.toArray(children);
  return (
    <Tabs isLazy className="admin-resource-tabs" colorScheme="blue">
      <TabList aria-label="Resource status">
        <Tab ref={activeTabRef}>Active</Tab>
        <Tab>Archived</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>{active}</TabPanel>
        <TabPanel>{archived}</TabPanel>
      </TabPanels>
    </Tabs>
  );
}
